import React, { useEffect } from 'react';

export const SupplementsSection = ({ 
    isLoggedIn, 
    supplementHistoryData, 
    handleSupplementSave,
    supplementText,
    setSupplementText,
    supplementDate,
    setSupplementDate
}) => {
    
    useEffect(() => {
        if (supplementHistoryData) supplementHistoryData.reverse();
    }, [supplementHistoryData]);

    return (
        <section className='ml-4 mr-4 pt-10'>
            <div className="flex items-center gap-2 mb-4 px-1">
                <span className="bg-emerald-500 text-white text-[10px] font-black px-2 py-0.5 rounded-md tracking-wider">02</span>
                <h3 className="text-lg font-black text-slate-800 tracking-tight">영양 / 보조제</h3>
            </div>
            <div className="relative card p-5 bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden">
                {!isLoggedIn && (
                    <div className="absolute inset-0 z-10 bg-white/60 backdrop-blur-[2px] flex flex-col items-center justify-center">
                        <div className="bg-slate-800 text-white px-4 py-3 rounded-2xl flex flex-col items-center shadow-xl">
                            <span className="material-icons-round text-2xl mb-1 text-emerald-400">lock</span>
                            <p className="text-xs font-bold text-center">로그인 이후에 서버 연동으로<br/>안전하게 사용할 수 있습니다.</p>
                        </div>
                    </div>
                )}
                <div className="flex gap-3 mb-4">
                    <input 
                        type="date" 
                        value={supplementDate} 
                        onChange={e => setSupplementDate(e.target.value)} 
                        className="flex-1 bg-slate-50 text-slate-700 text-sm font-bold rounded-2xl px-4 py-3 border border-slate-100 focus:ring-2 focus:ring-emerald-500 outline-none transition-all" 
                        disabled={!isLoggedIn} />
                </div>
                <div className="relative mb-4">
                    <textarea 
                        value={supplementText} 
                        onChange={e => setSupplementText(e.target.value)} 
                        maxLength={500} 
                        disabled={!isLoggedIn} 
                        placeholder="오늘 식단, 영양/보조제 종류, 섭취량, 특이사항 등을 기록해보세요. (최대 500자)" 
                        className="w-full h-32 bg-slate-50 text-slate-700 text-sm font-medium rounded-2xl px-4 py-3 border border-slate-100 focus:ring-2 focus:ring-emerald-500 outline-none transition-all resize-none"></textarea>
                    <div className={`absolute bottom-3 right-4 text-[10px] font-bold ${supplementText.length >= 500 ? 'text-rose-500' : 'text-slate-400'}`}>{supplementText.length} / 500</div>
                </div>
            </div>
        </section>
    );
};